/**
 * Origin for Socket.IO (no `/v1` path). Uses `VITE_OMNICHANNEL_SOCKET_URL` when set, otherwise `VITE_BASE_URL`.
 */
export function getOmnichannelSocketOrigin(): string | undefined {
  const explicit = import.meta.env.VITE_OMNICHANNEL_SOCKET_URL as
    | string
    | undefined;
  const base = import.meta.env.VITE_BASE_URL as string | undefined;
  const raw = (explicit || base)?.trim();
  if (!raw) return undefined;
  try {
    const u = new URL(raw.endsWith('/') ? raw.slice(0, -1) : raw);
    return `${u.protocol}//${u.host}`;
  } catch {
    return undefined;
  }
}
